import { initializeApp, getApps } from 'firebase/app'
import { getFirebaseWebConfig } from './config'

let app: ReturnType<typeof initializeApp> | null = null

export function getFirebaseApp() {
  if (!app) {
    if (getApps().length > 0) {
      app = getApps()[0]
    } else {
      app = initializeApp(getFirebaseWebConfig())
    }
  }
  return app
}
